import React from "react";
import { Stack, CircularProgress, Typography } from "@mui/material";

interface DownloadIndicatorProps {
  size?: number;
  label?: string;
  spacing?: number;
}

const DownloadIndicator: React.FC<DownloadIndicatorProps> = ({
  size = 16,
  label,
  spacing = 1,
}) => {
  return (
    <Stack direction="row" alignItems="center" spacing={spacing}>
      <CircularProgress size={size} />
      {label ? (
        <Typography variant="body2" component="span">
          {label}
        </Typography>
      ) : null}
    </Stack>
  );
};

export default DownloadIndicator;


